export default __webpack_public_path__ + "b68aa1cbf6b16be4c5abe6576e415bbe.png";